import { Link } from "react-router-dom";

import { Container, LogosContainer, NameContainer } from "./styles";
import { baseURLAPI } from "../../services/api";
import { getClientData } from "../../services/auth";
import { useAuth } from "../../contexts/AppContext";

import Clock from "./components/Clock";

import logoEgam from "../../assets/images/logo-egam-internal.png";
import handshake from "../../assets/images/handshake-internal.png";
import { Box } from "@mui/material";
import { CustomerSelect } from "../CustomerSelect";

const Header = () => {
  const { clientData: clientDataFromContext } = useAuth();
  const clientData = clientDataFromContext || getClientData();

  let projectId: number | false = false;
  let clientNameShow: string | false = false;
  if (clientData !== null) {
    const { cd_logged_project: project, ds_cliente: clientName } = clientData;
    projectId = project;
    clientNameShow = clientName;
  }

  return (
    <Container>
      <Link to="/">
        <LogosContainer>
          <img src={logoEgam} alt="eGAM" />
          <img className="handshakeInternal" src={handshake} alt="handshake" />
          {projectId && (
            <img
              src={`${baseURLAPI}static/projects/${projectId}/logo-internal.png`}
              alt="Parceiro"
            />
          )}
        </LogosContainer>
      </Link>

      <NameContainer>
        {clientNameShow && (
          <>
            Olá, {clientNameShow}!<br />
          </>
        )}
        Seja Bem-vindo!
      </NameContainer>

      <Box display="flex" justifyContent="flex-end" style={{ gap: "15px" }}>
        <CustomerSelect />
        <Clock />
      </Box>
    </Container>
  );
};

export default Header;
